// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.change-address-btn[data-v-fb380594] {
  position: relative;
  z-index: 2;
}
.change-address-btn[data-v-fb380594] .v-btn {
  position: absolute;
  right: 0;
  top: -4px;
  font-size: 12px;
  margin: 0px;
  min-width: auto;
}
.change-address-btn[data-v-fb380594] .v-btn .v-btn__content {
  padding: 0px;
  padding-right: 8px;
}
.v-align[data-v-fb380594] {
  position: relative;
  top: 2px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
